import { useFormContext } from 'react-hook-form'
import { FormItem } from 'vnetwork-ui'
import { CreateProcessFormData } from './index'

const ProcessFormFields = () => {
    const { control } = useFormContext<CreateProcessFormData>()

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div data-tour="warehouse-process-date">
                    <FormItem
                        control={control}
                        name="process_date"
                        label="Process Date *"
                        type="datepicker"
                    />
                </div>
                <div data-tour="warehouse-expected-date">
                    <FormItem
                        control={control}
                        name="expected_date"
                        label="Expected Date"
                        type="datepicker"
                    />
                </div>
            </div>

            <div data-tour="warehouse-reason">
                <FormItem
                    control={control}
                    name="reason"
                    label="Reason *"
                    type="textfield"
                    placeholder="Enter reason for this process..."
                />
            </div>

            <div data-tour="warehouse-description">
                <FormItem
                    control={control}
                    name="description"
                    label="Description"
                    type="textarea"
                    placeholder="Enter detailed description..."
                />
            </div>

            <div data-tour="warehouse-notes">
                <FormItem
                    control={control}
                    name="notes"
                    label="Notes"
                    type="textarea"
                    placeholder="Additional notes..."
                />
            </div>
        </div>
    )
}

export default ProcessFormFields
